<modal
  class="NavMobileMenu NavMobileMenu--content-scroll-auto"
  [config]="{
    type: 'flyout',
    direction: 'left',
    header: {
      title: 'Menu',
    },
  }"
  [condition]="data.isMobileMenuOpen"
  (cancel)="toggleMobileMenu(false)"
>
  <section class="NavMobileMenu__Body" body>
    @if (data.isMobileMenuOpen) {
      <mobile-language-switcher
        [config]="config.languagesSwitcher"
        [activeLangKey]="activeLangKey"
        [isMobileView]="true"
        (languageSwitched)="handleSwitchLanguageClicked($event)"
      ></mobile-language-switcher>
      @if (config.dropdown) {
        <dropdown
          [options]="config.dropdown?.options"
          [value]="config.dropdown?.selectedOption?.id"
          [displayProperty]="config.dropdown.displayProperty"
          [disabled]="
            config.dropdown?.options?.length === 1 &&
            !config.dropdown.isDisabled
          "
          [isMobileView]="true"
          key="id"
          (selectOption)="selectOption($event)"
          data-test-id="policySelector"
          class="NavMobileMenu__ListItem"
        >
          <icon name="work" [config]="{ fill: 'nav-icon-color' }" prefix></icon>
        </dropdown>
      }
      <nav-icons
        [data]="iconData"
        (navItemClicked)="clickNavItem($event)"
        (logoutClicked)="logout()"
      >
      </nav-icons>
      <div class="NavLink u-maxX">
        <a
          class="NavLink__label u-maxX"
          routerLink="/"
          (click)="clickNavItem({ route: '/' })"
          (keydown.enter)="clickNavItem({ route: '/' })"
          tabindex="0"
        >
          <div class="u-flex u-alignCenter u-maxX">
            <icon class="NavLink__icon" [name]="getHomeIcon()"></icon>
            <p class="NavLink__title">Home</p>
          </div>
        </a>
      </div>
      <nav-links
        [config]="linksConfig"
        [data]="data"
        [externalSiteModalConfig]="externalSiteModalConfig"
        (navItemClicked)="clickNavItem($event)"
        [isMobileMenu]="true"
      >
      </nav-links>
      @if (config.buttons?.contactUs) {
        <div class="NavLink">
          <a
            class="NavLink__label"
            (click)="toggleContactUs()"
            (keydown.enter)="toggleContactUs()"
            tabindex="0"
          >
            <p class="NavLink__title">
              {{ config.buttons.contactUs.buttonText }}
            </p>
          </a>
        </div>
      }
    }
  </section>

  <footer class="NavMobileMenu__Footer" footer>
    @if (config.buttons?.auth) {
      @if (data.isUserLoggedIn) {
        <zip-button
          [config]="{
            content: config.buttons.auth.logout.content,
            level: config.buttons.auth.logout.level,
            size: 'fullWidth',
          }"
          (zipButtonClicked)="logout()"
        >
        </zip-button>
      } @else {
        <a routerLink="/">
          <zip-button
            [config]="{
              content: config.buttons.auth.login.content,
              level: config.buttons.auth.login.level,
              size: 'fullWidth',
            }"
            (zipButtonClicked)="login()"
          >
          </zip-button>
        </a>
      }
    } @else {
      <a class="NavLink" (click)="logout()" tabindex="0">
        <div class="NavLink__label">
          <div class="u-flex u-alignCenter">
            <div class="NavLink__icon">
              <icon name="exit"></icon>
            </div>
            <p class="NavLink__title">{{ getLogOutLabel() }}</p>
          </div>
        </div>
      </a>
    }
  </footer>
</modal>
